<template>
  <section class="agenda">
    <div class="agenda__content container">
      <div class="agenda__date">
        <div class="date__container">
          <div>
            <h1 class="date__title">
              Monday, Aug 25th
            </h1>
          </div>
          <button class="rotate-btn" v-bind:class="{ 'is-rotated': isRotated, 'iphone-btn': isIphone }"
          @click="seccionVisible = !seccionVisible" v-on:click="toggleRotation">
            <svg :class="{ 'iphone': isIphone }" width="14px" height="9px" viewBox="0 0 18 11">
              <path fill="#3AADCC" d="M9.1,7.8l6.6-6.6C15.8,1.1,16,1,16.1,0.9c0.2,0,0.4-0.1,0.6-0.1c0.2,0,0.4,0,0.5,0.1c0.2,0.1,0.3,0.2,0.4,0.3
              s0.2,0.3,0.3,0.4C18,1.8,18,2,18,2.2s0,0.4-0.1,0.5c-0.1,0.2-0.2,0.3-0.3,0.4l-7.5,7.5C9.8,10.8,9.5,11,9.2,11
              c-0.4,0-0.7-0.1-0.9-0.4L0.8,3.1C0.7,3,0.6,2.8,0.5,2.7C0.3,2.5,0.2,2.4,0.2,2.2c0-0.2,0-0.4,0.1-0.5c0.1-0.2,0.2-0.3,0.3-0.4
              S0.9,1.1,1,1c0.2-0.1,0.4-0.2,0.6-0.2c0.2,0,0.4,0,0.5,0.1C2.3,1,2.4,1.1,2.5,1.2L9.1,7.8z"/>
            </svg>
          </button>
        </div>
        <hr class="date__line">
      </div>
      <transition name="fade">
        <div v-show="seccionVisible">
          <div class="cards__container">
            <div class="cards__single grayblue">
              <p class="cards__title">
                Doors Open
              </p>
              <div class="cards__description">
                <p>11:00 AM</p>
              </div>
            </div>
            <div v-for="(speaker, index) in morningSet" :key="index" class="cards__single cerulean" :class="speaker.class">
              <div v-if="speaker.imgClass" :class="'speaker-img ' + speaker.imgClass"></div>
              <div v-if="speaker.logoClass" :class="'logo-img ' + speaker.logoClass"></div>
              <div v-if="speaker.imgClass" class="circle"></div>
              <div class="cards__speaker">
                <p class="cards__name">{{ speaker.name }}</p>
                <p class="cards__spktitle" v-html="speaker.position"></p>
                <p v-if="speaker.title" class="cards__spktitle" v-html="speaker.title"></p>
              </div>
              <div class="cards__description">
                <p class="time">{{ speaker.time }}</p>
                <p v-if="speaker.location" class="location">{{ speaker.location }}</p>
              </div>
            </div>
            <div class="cards__single grayblue">
              <p class="cards__title">
                Lunch
              </p>
              <div class="cards__description">
                <p>12:30 PM - 2:00 PM</p>
              </div>
            </div>
            <div v-for="(speaker, index) in afternoonSet" :key="index" class="cards__single cerulean" :class="speaker.class">
              <div v-if="speaker.imgClass" :class="'speaker-img ' + speaker.imgClass"></div>
              <div v-if="speaker.logoClass" :class="'logo-img ' + speaker.logoClass"></div>
              <div v-if="speaker.imgClass" class="circle"></div>
              <div class="cards__speaker">
                <p class="cards__name">{{ speaker.name }}</p>
                <p class="cards__spktitle" v-html="speaker.position"></p>
                <p v-if="speaker.title" class="cards__spktitle" v-html="speaker.title"></p>
              </div>
              <div class="cards__description">
                <p class="time">{{ speaker.time }}</p>
                <p v-if="speaker.location" class="location">{{ speaker.location }}</p>
              </div>
            </div>
          </div>
          <div class="cards__container">
            <div class="cards__single cocktail">
              <p class="cards__title">
                Cocktail Hour
              </p>
              <div class="cards__description">
                <p>6:00 PM - 7:30 PM</p>
              </div>
            </div>
            <div class="cards__single dinner">
              <p class="cards__title">
                Whale Supper Club
              </p>
              <div class="cards__description">
                <p>7:30 PM - 10:00 PM</p>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </section>
</template>

<style lang="scss">
  @import '@/styles/components/agenda.scss';
</style>

<script>
export default {
  name: 'Day One',
  data() {
    return {
      seccionVisible: true,
      isRotated: false,
      isIphone: false,
      morningSet: [
        {
          imgClass: 'miglino',
          name: 'Chris Miglino',
          position: 'CEO, Co-Founder - DNA',
          title: 'Opening Remarks - Welcome Keynote',
          time: '11:00 AM - 11:30 AM',
        },
      ],
      afternoonSet: [
        {
          name: 'The Fast Lane: Solana, DePIN, and the Onchain Economy',
          title: 'Panel Moderator: Lu Yin - Solana Foundation<br>Mike Eidlin - Jupiter Japan<br>Ryot Seo - Xitadel<br>Peter Teng - Zeus Network',
          time: '1:30 PM - 2:00 PM',
          class: 'noheight panel'
        },
        {
          name: 'Web3 Payments: The Final Frontier of Financial Innovation',
          title: 'Panel Moderator: Hose Mitamura - Cointelegraph Japan<br>Tokio Nakamoto - Slash Vision Labs<br>Mai Fujimoto - INTMAX<br>Adeola Adewewe - Kredete',
          time: '2:00 PM - 2:30 PM',
          class: 'noheight panel'
        },
        {
          name: 'Foundations of the Future: Competing Chains & the New Internet of Value',
          title: 'Toshihiko Kamei - Fracton Ventures<br>Ken Kashiwagi - Sui / Mysten Labs<br>Mason Cagnoni - Abstract<br>Mo Jalil - Ethereum Foundation<br>John Cho - Kaia',
          time: '2:30 PM - 3:00 PM',
          class: 'noheight panel'
        },
        {
          name: 'DNA Presents: Vision to Venture',
          title: 'Interviewer: Joe Ross - DNA<br>Robert Hirsch, Ph.D - Zkalyx<br>Jakub Zurawinski - American Fortress<br>Maurice Ng - Planck',
          time: '3:00 PM - 3:30 PM',
          class: 'noheight panel'
        },
        {
          name: 'The Future Is Tokenized: Where Capital Markets and Web3 Collide',
          title: 'Panel Moderator: Jake Flaherty - DNA<br>Ann Chien - IVC<br>Deng Chao - Hashkey Capital<br>Sandeep Casi - Antler',
          time: '3:30 PM - 4:00 PM',
          class: 'noheight panel'
        },
        {
          name: 'DNA Presents: Vision to Venture',
          title: 'Interviewer: Joe Ross - DNA<br>Adeola Adewewe - Kredete<br>Toby Gilbert - Pact Swap<br>Katia Zaitsev - Own. App',
          time: '4:00 PM - 4:30 PM',
          class: 'noheight panel'
        },
        {
          imgClass: 'y-c',
          name: 'Fireside Chat: Chris Miglino & Yat Siu',
          title: 'Yat Siu - Animoca Brands<br> Chris Miglino - DNA',
          time: '4:30 PM - 5:00 PM',
          class: 'noheight special'
        },
        {
          name: 'From Japan to the World: Cardano’s Vision for Privacy, Real-World Assets, and the Future of Finance',
          title: 'Panel Moderator: Jake Flaherty - DNA<br>Phillip Pon - EMURGO<br>Adam Wasserman - Input Output<br>Sebastien Guillemot - Midnight',
          time: '5:00 PM - 5:30 PM',
          class: 'noheight panel'
        },
        {
          name: 'Cultural Protocols: Music, Art, and Identity in Web3',
          title: 'Panel Moderator: Taehee Oh - 071 Labs<br>Sara Giusto - AWW<br>Stroll - MokeDAO<br>Abby Huang - Story Protocol',
          time: '5:30 PM - 6:00 PM',
          class: 'noheight panel'
        },
        {
          name: 'Introduction to Bittensor and DEAI Community',
          time: '6:00 PM - 6:30 PM',
          class: 'noheight panel'
        },
      ]
    }
  },
  methods: {
    toggleRotation() {
      this.isRotated = !this.isRotated;
    },
  },
  mounted() {
    this.isIphone = /iPhone/.test(navigator.userAgent);
  }
};
</script>
